import {
  DropdownMenu,
  GhostIconButton,
  MenuItem,
  MenuSection,
  showToast,
  Text,
} from "@certn/cascadia-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { ReactivateDeactivateModal } from "./ReactivateDeactivateModal";

interface Props {
  templateIdsBelongingToActivePackages?: string[];
  templateId: string;
  name: string;
  isActive: boolean;
  numActiveTemplates: number;
  mutate: () => void;
}
export function ActionsDropdown(props: Props) {
  const {
    name,
    templateId,
    isActive,
    numActiveTemplates,
    mutate,
    templateIdsBelongingToActivePackages = [],
  } = props;
  const { templateId: templateIdQueryParam } = useParams();
  const { t } = useTranslation();
  const [reactivateDeactivateModalIsOpen, setReactivateDeactivateModalIsOpen] =
    useState(false);
  const navigate = useNavigate();

  const handleSuccess = () => {
    mutate();
    const message = isActive
      ? t(" has been deactivated.")
      : t(" has been reactivated.");
    showToast(name + message, {
      type: "success",
    });
    setReactivateDeactivateModalIsOpen(false);
  };

  const currentTemplate = templateIdQueryParam || templateId;
  const isTemplateInActivePackage =
    templateIdsBelongingToActivePackages.includes(currentTemplate);

  const unableToDeactivate =
    numActiveTemplates && numActiveTemplates < 2 && isActive;
  const hideDropDownOnEditPage = templateIdQueryParam && unableToDeactivate;

  return (
    <>
      {!hideDropDownOnEditPage && (
        <DropdownMenu
          triggerButton={
            <GhostIconButton
              testID="templates-item-expand-button"
              size="small"
              icon="more_horiz"
              aria-label={t("Expand menu")}
            />
          }
          placement="bottom right"
          onItemAction={async (key) => {
            switch (key) {
              case "edit-template":
                navigate(
                  `/settings/credential-verification-templates/${templateId}`
                );
                break;
              case "deactivate-template":
                setReactivateDeactivateModalIsOpen(true);
                break;
              case "activate-template":
                setReactivateDeactivateModalIsOpen(true);
                break;
            }
          }}
        >
          <MenuSection>
            <>
              {!templateIdQueryParam && (
                <MenuItem id="edit-template" testID="edit-template">
                  <Text style="input/text-field">{t("Edit")}</Text>
                </MenuItem>
              )}
              {numActiveTemplates && numActiveTemplates >= 2 && isActive && (
                <MenuItem id="deactivate-template" testID="deactivate-template">
                  <Text color="text-danger" style="input/text-field">
                    {t("Deactivate")}
                  </Text>
                </MenuItem>
              )}
              {!isActive && (
                <MenuItem id="activate-template" testID="activate-template">
                  <Text style="input/text-field">{t("Activate")}</Text>
                </MenuItem>
              )}
            </>
          </MenuSection>
        </DropdownMenu>
      )}
      {reactivateDeactivateModalIsOpen && (
        <ReactivateDeactivateModal
          isTemplateInActivePackage={isTemplateInActivePackage}
          templateID={templateId}
          isActivatingTemplate={!isActive}
          onSuccess={() => handleSuccess()}
          close={() => setReactivateDeactivateModalIsOpen(false)}
        />
      )}
    </>
  );
}
